import ProfilePage from "./Profile/Page"
import { useState } from 'react';
import Controller from "./Controller/Manager"
import ControllerConfig from "./ControllerConfig"

function sortByDate(timeline) {
  let r = {}

  for (let i in timeline) {
    let exp = timeline[i]
    exp.start = new Date(exp.start)
    exp.end = new Date(exp.end)
    exp.enabled = true
    r[exp.start.getTime()] = exp
  }

  return Object.keys(r).sort().reduce(
    (obj, o) => {
      obj[obj.length] = r[o]
      return obj
    },
    []
  )
}

export default function Profile({ profileUrl }) {
    const initStyle = ControllerConfig(Object.keys(profileUrl))
	const [language, setLanguage] = useState(null)
    const [style, setStyle] = useState(initStyle)
	const [profile, setProfile] = useState({
		identity: {
			lastname: "",
			firstname: "",
			email: ""
		},
        networking: {
            github: ""
        },
		state: {},
		skills: []
	})
    const [careers, setCareers] = useState([])
    const [skills, setSkills] = useState({})
    const [stories, setStories] = useState([])

	const radar = Object.freeze(
	  {
	    max: 5,
	    metrics: ["Frontend", "Backend", "DevOps", "Monitoring", "Infra"],
	  }
	)

    const [categories, setCategories] = useState(radar.metrics.reduce((obj, m) => {
        obj[m] = true
        return obj
    }, {}))

    function updateSkills(profile) { 
        return profile.skills.reduce((obj, skill) => {
            if (!skill.category || categories[skill.category]) {
                if (skill.display !== false) {
                    if (skill.enabled == undefined) {
                        try {
                            skill.enabled = skills[skill] || true
                        }catch(e) {
                            skill.enabled = true
                        }
                    }

                    obj[skill.name] = skill
                }
            }

            return obj
        }, {})
    }

	function changeLanguage(newLanguage) {
		if (language == newLanguage){
			return;
		}

		setLanguage(newLanguage)

		fetch(profileUrl[newLanguage]).then((response) => {
            response.json().then((profile) => {
                fetch("./skills.json").then((response) => {
                    response.json().then((skills) => {
                        update({
                            skills: skills,
                            ...profile
                        })
                    })
                })
            })
		})

		return newLanguage
	}

	function update(profile) {
	    profile.timeline = sortByDate(profile.timeline)
	    setProfile(profile)
	    setCareers(profile.timeline)
	    setSkills(updateSkills(profile))
	    setStories(updateStories(profile.timeline))
	}


    function toggleCategory(category) {
        let newValue = !categories[category]
        categories[category] = newValue

        setCategories(categories)
        update(profile)

        return newValue
    }

    function toggleSkill(skill) {
        let newValue = !skills[skill].enabled || false
        skills[skill].enabled = newValue

        setSkills(updateSkills(profile))

        return newValue
    }


    function updateStories(careers) {
        return careers.filter(
                (career) => career.enabled
            ).reverse().reduce(
                (obj, company) => (company.stories || []).reduce(
                    (obj, item) => {
                        obj.push({
                            company: company,
                            project: item.project,
                            story: item
                        })
                        return obj
                    },
                    obj
                ), 
                []
            )
    }

    function toggleCareer(career) {
    	career.enabled = !career.enabled
    	setCareers(careers)
    	setStories(updateStories(careers))

        return career.enabled
    }

	function toggleLanguage() {
		changeLanguage("en")
	}

	if (!profileUrl[language]) {
		changeLanguage(initStyle.language.use)
	}

    function updateStyle(style) {
        setStyle({
            ...initStyle,
            ...(style || {})
        })
    }

    const languages = Object.keys(profileUrl)
    let params = new URLSearchParams(document.location.search);
    const displayer = [
        {
            name: "profilepage",
            item: <ProfilePage
                key="ProfilePage"
                profile={ profile }
                radar={ radar }
                careers={ careers }
                skills={ skills }
                stories={ stories }
                toggleCategory={ toggleCategory }
                toggleSkill={ toggleSkill }
                toggleCareer={ toggleCareer }
                toggleLanguage={ toggleLanguage }
                style={ style }
            />,
            enabled: true
        },
        {
            name: "controller",
            item: <Controller 
                    key="Controller"
                    useStyle={[
                        style,
                        updateStyle
                    ]}
                    useLanguages={[
                        language,
                        changeLanguage,
                        languages
                    ]}
                />,
            enabled: Boolean(params.get("controller"))
        }
    ]

	return (
        displayer.filter((component) => component.enabled).map((component) => component.item)
	)
}